import React,{useState} from 'react';
import Slider from 'react-slick'; 
import './VerificationDashboard.css';
// import { Link } from 'react-router-dom';
import BetaWaitlist from '../../Beta-Waitlist/BetaWaitlist';
//import JoinPriorityWaitlistBtn from '../../ViralLoops/JoinPriorityWaitlistBtn';

const PrevArrow = (props) => (
  <button {...props} className="slick-prev">
    <img src="/img/RentID/arrow_left_sky.svg" alt="Previous" width="48" height="48" />
  </button>
);

const NextArrow = (props) => (
  <button {...props} className="slick-next">
    <img src="/img/RentID/arrow_right_sky.svg" alt="Next" width="48" height="48" />
  </button>
);

const VerificationDashboard = () => {

  const [showWaitlist, setShowWaitlist] = useState(false);
// START cards
// const cards = [
//   { 
//     id: 1, 
//     image: '/img/RentID/dash_1.webp',
//     span: '01', 
//     heading: 'Real-Time Alerts', 
//     text: 'Stay informed with instant notifications about critical verification events.' },
    
//   { 
//     id: 2, 
//     image: '/img/RentID/dash_2.webp',
//     span: '02', 
//     heading: 'Status Tracking', 
//     text: 'Keep track of the verification status for each renter in real-time.' },
//   { 
//     id: 3, 
//     image: '/img/RentID/dash_3.webp',
//     span: '03', 
//     heading: 'Risk Indicators', 
//     text: 'Visualize risk levels associated with each renter through clear indicators.' },
//   { 
//     id: 4, 
//     image: '/img/RentID/dash_4.png',
//     span: '04', 
//     heading: 'Trend Monitoring', 
//     text: 'Identify and respond to emerging patterns that may impact your business.' },
//   { 
//     id: 5, 
//     image: '/img/RentID/dash_5.webp',
//     span: '05', 
//     heading: 'Analytics Reporting', 
//     text: 'Generate insightful reports to understand verification trends and performance.' },
//   { 
//     id: 6, 
//     image: '/img/RentID/rent-id-logo-testi.svg',
//     heading1: 'Manage rental risk like a pro', 
//     link: 'Join the Waitlist' },
//  ];
// END cards


  // START Slick
 const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    margin: 30,
    autoplay: true,
    autoplaySpeed: 2000,

    // autoplaySpeed: 0,  // No delay between scrolls
    // speed: 4000,  // Smooth continuous movement
    // cssEase: 'linear',

    loop: true,
    dots: false,
    arrows: false,
    focusOnSelect: true,
    centerPadding: '30px',
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3, // Correcting the key to 'slidesToShow'
          infinite: false,
          centerPadding: "20px",
          margin: 30,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2, // Correcting the key to 'slidesToShow'
          centerPadding: "20px",
          margin: 20,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1, // Correcting the key to 'slidesToShow'
          margin: 20,
        },
      },
    ],
  }; 

  return (
    <section className="veriDashMain" id='VerificationDashboard'>
      <img className="veriDash_1" src="/img/RentID/timeline_1.svg" alt="Verification Dashboard"/>
      <div className="container">

        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="veriDashHeading justify-content-center align-items-center">
                    <figure><img className="img-fluid" width="48px" height="48px" src="/img/RentID/veriDash_icon.svg" alt="Verification Dashboard"/></figure>
                    <div className="commonText">
                        <h2>Verification Dashboard</h2>
                        <p>Centralized risk management for hosts and staff.</p>
                    </div>
                </div>
            </div>
        </div>
      </div>
          {/* <div className="rentIdSlider">
            <div className="carousel-container mt-2">
              <div className="carousel">
              <div className="carousel-track">
                {cards.map((card, index) => (
                  <div key={card.id} className="card veriDashDetail">
                    {index === 5 ? (
                      <>
                        <img src={card.image} alt={card.heading1} className="img-fluid" />
                        <h4>{card.heading1}</h4>
                      </>
                    ) : (
                      <>
                        <span>{card.span}</span>
                        <h3>{card.heading}</h3>
                      </>
                    )}
                    <p>{card.text}</p>

                    {index !== 5 && (
                      <img src={card.image} alt={card.heading} className="img-fluid" />
                    )}

                    {index === 5 && (
                      <>
                       <BetaWaitlist
                                    showJoinWaitList={showWaitlist}
                                    onClose={() => setShowWaitlist(false)}
                                    onOpen={() => setShowWaitlist(true)}
                                />

                            <button onClick={() => setShowWaitlist(true)} className="btn">
                                Join The Waitlist
                            </button>
                      </>
                      // <JoinPriorityWaitlistBtn buttonclass="btn" buttonText="Join The Waitlist"  />
                    )}
                  </div>
                ))}
              </div>
                 
                <div className="carousel-track">
                {cards.map((card , index) => (
                  <div key={`duplicate-${card.id}`} className="card veriDashDetail">
            
                      {index === 5 ? (
                          <>
                            <img src={card.image} alt={card.heading1} className="img-fluid" />
                            <h4>{card.heading1}</h4>
                          </>
                        ) : (
                          <>
                            <span>{card.span}</span>
                            <h3>{card.heading}</h3>
                          </>
                        )}
                        <p>{card.text}</p>

                        {index !== 5 && (
                          <img src={card.image} alt={card.heading} className="img-fluid" />
                        )}

                        {index === 5 && (
                          <Link className="btn" to="/?signup=waitlist">
                            {card.link}
                          </Link>
                        )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div> */}

          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <Slider {...settings} className="veriDashDetailOuter">
                  <div className="item">
                      <div className="veriDashDetail veriDashDetail_1">
                          <span>01</span>
                          <h3>Real-Time Alerts</h3>
                          <p>Stay informed with instant notifications about critical verification events.</p>
                          <img className="img-fluid" src="/img/RentID/dash_1.webp" alt="icon"/>
                      </div>
                  </div> 
                  <div className="item">
                      <div className="veriDashDetail veriDashDetail_2">
                          <span>02</span>
                          <h3>Status Tracking</h3>
                          <p>Keep track of the verification status for each renter in real-time.</p>
                          <img className="img-fluid" src="/img/RentID/dash_2.webp" alt="icon"/>
                      </div>
                  </div> 
                  <div className="item">
                      <div className="veriDashDetail veriDashDetail_3">
                          <span>03</span>
                          <h3>Risk Indicators</h3>
                          <p>Visualize risk levels associated with each renter through clear indicators.</p>
                          <img className="img-fluid" width="300px" src="/img/RentID/dash_3.webp" alt="icon"/>
                      </div>
                  </div>
                  <div className="item">
                      <div className="veriDashDetail veriDashDetail_4">
                          <span>04</span>
                          <h3>Trend Monitoring</h3>
                          <p>Identify and respond to emerging patterns that may impact your business.</p>
                          <img className="img-fluid" src="/img/RentID/dash_4.png" alt="icon"/>
                      </div>
                  </div> 
                <div className="item">
                      <div className="veriDashDetail veriDashDetail_5">
                          <span>05</span>
                          <h3>Analytics Reporting</h3>
                          <p>Generate insightful reports to understand verification trends and performance.</p>
                          <img className="img-fluid" src="/img/RentID/dash_5.webp" alt="icon"/>
                      </div>
                  </div>

                  <div className="item">
                      <div className="veriDashDetail veriDashDetail_6">
                          <img className="img-fluid" src="/img/RentID/rent-id-logo-testi.svg" alt="icon"/>
                          <h4>Manage rental<br/> risk like a pro</h4>
                          {/* <Link className="btn" to="/?signup=waitlist">Join the Waitlist</Link> */}
                          <BetaWaitlist
                                showJoinWaitList={showWaitlist}
                                onClose={() => setShowWaitlist(false)}
                                onOpen={() => setShowWaitlist(true)}
                            />
                          <button onClick={() => setShowWaitlist(true)} className="btn">
                                Join The Waitlist
                            </button>
                      </div>
                  </div>   
  
              </Slider> 
            </div>
          </div> 

    </section>
  );
};

export default VerificationDashboard;
